import React,{Component} from 'react';

import './OnlineMissions.css';

import { background_2, image2 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Counters from '../../components/Counters/Counters';
import CumulativeStatistics from './content/CumulativeStatistics/CumulativeStatistics';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';

import { get_data_file_url, get_text_counter } from '../../utils/data';
import WeeklyStatistics from './content/WeeklyStatistics/WeeklyStatistics';
import { get_page_title } from '../../utils/config';
import { Helmet } from 'react-helmet';

interface Props{
}
interface State{
    loading: boolean,
    data? :any,
    
    loading_counters: boolean,
    counter_data? :any,
}



export default class OnlineMissions extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            loading: false,
            loading_counters: false,
        }
    }

    componentDidMount(){
        this.fetch_data();
        this.fetch_counter_data();
    }
    
    fetch_counter_data = async () => {
        this.setState({ loading_counters: true });
        try {
            let res = await request(get_data_file_url(`online_stats.json`), { method: 'get' })

            this.setState({ counter_data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_counter_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading_counters: false })
        }
    }
    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(`online_info_data_chart.json`), {
                method: 'get'
            })

            // console.debug("data", res.data);


            this.setState({ data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    render(){
        let tabs = [
            {
                label: <>Cumulative Statistics</>,
                content: <div className="online-missions-content">
                    <CumulativeStatistics data={this.state.data} loading={this.state.loading}/>
                </div>
            },
            {
                label: <>Weekly Statistics</>,
                content: <div className="online-missions-content">
                    <WeeklyStatistics data={this.state.data} loading={this.state.loading}/>
                </div>
            },
        ]
        return (
        <Page 
            id="online-missions"
            banner={{
                title: "online missions",
                bannerImage: background_2,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title(`DAMPS - Online Missions`) }</title>
                <meta 
                    name="description" 
                    content="DAMPS online missions details"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <Counters
                        counters={[
                            get_text_counter("VOLUME OF ARCHIVED PRODUCTS", this.state.counter_data?.size, this.state.loading_counters),
                            get_text_counter("NUMBER OF ARCHIVED PRODUCTS", this.state.counter_data?.prod, this.state.loading_counters),
                        ]}
                    />
                    {/* <Counters
                        counters={[
                            {
                                name: "VOLUME OF ARCHIVED PRODUCTS",
                                value: 632.3,
                                unit: "Tera Bytes",
                            },
                            {
                                name: "NUMBER OF ARCHIVED PRODUCTS",
                                value: 762.62,
                                unit: "Thousand",
                            }
                        ]}
                    /> */}
                </div>
                <div className="centered-content padding">
                    {/* <div className="">
                    </div> */}
                    <Tabs tabs={tabs}/>
                </div>
            </div>
        </Page>
        );
    }


};
